import React, { Component } from 'react';
import './autocomplete.css';
import axios from 'axios';

export default class AutocompletePlace extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            results: [],
            isLoading: false,
        };
        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    handleSearchChange(e) {
        this.setState({
            search: e.target.value,
            isLoading: true,
        });

        // Stop the previous setTimeout if there is one in progress
        clearTimeout(this.timeoutId);

        // Launch a new request in 1000ms
        this.timeoutId = setTimeout(() => {
            this.performSearch();
        }, 500);
    }

    performSearch() {
        if (this.state.search === '') {
            this.setState({
                results: [],
                isLoading: false,
            });
            return;
        }

        axios
            .get(
                `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.state.search}.json?types=address,poi&country=au&access_token=${this.props.api}`
            )
            .then((response) => {
                this.setState({
                    results: response.data.features,
                    isLoading: false,
                });
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            });
    }

    handleItemClicked(place) {
        this.setState({
            search: place.place_name,
            results: [],
        });
        this.props.onSelect(place);
    }

    componentDidUpdate(prevProp) {
        if (prevProp.inputValue !== this.props.inputValue) {
            this.setState({
                search: this.props.inputValue,
            });
        }
    }

    componentDidMount() {
        this.setState({
            search: this.props.inputValue,
        });
    }

    render() {
        return (
            <div className="AutocompletePlace">
                <input
                    className={
                        this.props.className === 'inputerror'
                            ? 'AutocompletePlace-input inputerror'
                            : 'AutocompletePlace-input'
                    }
                    type="text"
                    value={this.state.search || ''}
                    onChange={this.handleSearchChange}
                    placeholder="Type an address"
                    autoComplete="new-password"
                />
                <ul className="AutocompletePlace-results">
                    {this.state.results.map((place) => (
                        <li
                            key={place.id}
                            className="AutocompletePlace-items"
                            onClick={() => this.handleItemClicked(place)}
                            onKeyDown={() => this.handleItemClicked(place)}
                        >
                            {place.place_name}
                        </li>
                    ))}

                    {this.state.isLoading && (
                        <li className="AutocompletePlace-items">Loading...</li>
                    )}
                </ul>
            </div>
        );
    }
}
